import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HeaderBar from "@/auth/HeaderBar";
import Footer from "@/components/landing/Footer";
import { useCart } from "@/cart/CartProvider";

/**
 * Reusable layout for static text pages (privacy, terms, refund, etc).
 * Pass `title`, `lastUpdated`, and `children` (the body markup).
 */
export default function LegalPage({ title, lastUpdated, children }) {
    const { openAuth } = useCart();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = `${title} · Caribbean Meal Prep`;
    }, [title]);

    return (
        <div className="min-h-screen bg-cream text-navy font-sans flex flex-col">
            <div className="relative hero-gradient text-white pb-20 pt-32 px-6">
                <HeaderBar onSignIn={openAuth} dark />
                <div className="max-w-3xl mx-auto">
                    <Link
                        to="/"
                        data-testid="legal-back-home"
                        className="inline-flex items-center gap-1.5 text-mint hover:text-gold transition-colors text-sm font-medium"
                    >
                        <ArrowLeft size={16} /> Back to home
                    </Link>
                    <p className="mt-6 text-[11px] tracking-[0.4em] text-gold font-bold uppercase">
                        Caribbean Meal Prep
                    </p>
                    <h1
                        data-testid="legal-title"
                        className="mt-3 font-serif font-black text-4xl sm:text-5xl md:text-6xl leading-[1.05]"
                    >
                        {title}
                    </h1>
                    {lastUpdated && (
                        <p className="mt-4 text-white/70 text-sm">
                            Last updated: {lastUpdated}
                        </p>
                    )}
                </div>
            </div>

            <main
                data-testid="legal-content"
                className="flex-1 max-w-3xl w-full mx-auto px-6 py-16 prose prose-legal"
            >
                {children}
            </main>

            <Footer />
        </div>
    );
}
